import { CaptchaProvider } from '../../config/networkConfig';
import { EventPayload } from '../../events';

export default class CaptchaEventPayload implements EventPayload {
  provider: CaptchaProvider;

  captchaToken?: string;

  recaptchaToken?: string;

  civicPassAuthToken?: string;

  constructor(provider: CaptchaProvider, token: string, civicPassAuthToken?: string) {
    this.provider = provider;
    this.civicPassAuthToken = civicPassAuthToken;

    if (provider === CaptchaProvider.RECAPTCHA) {
      this.recaptchaToken = token;
    } else if (provider === CaptchaProvider.HCAPTCHA) {
      this.captchaToken = token;
    }
  }
}
